/**
 * WordPress dependencies
 */
import { createSlotFill } from '@wordpress/components';

const CommentIconSlotFill = createSlotFill( Symbol( 'CommentIconSlotFill' ) );

export default CommentIconSlotFill;
